import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PromotionAction } from 'src/app/models/promotionAction.model';

@Component({
    selector: 'promotion-detail-dialog',
    templateUrl: './promotion-detail-dialog.component.html',
    styleUrl: './promotion-detail-dialog.component.scss',
    standalone: false
})
export class PromotionDetailDialogComponent {
  promotionAction: PromotionAction = this.data.promotionAction;

  constructor(
    private readonly dialogRef: MatDialogRef<PromotionDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      promotionAction: PromotionAction;
    },
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
